import * as React from 'react'
import { Alert, Button, Col, Form, Input, Row, Select } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import { Controller, useForm } from 'react-hook-form'

import { WALLET_CURRENCIES, WALLET_NETWORKS } from '../../config'
import { TxidCheckFormData, TxidCheckFormProps } from './types'

const colProps = { xs: 24, md: 12 }

export const TxidCheckForm: React.FC<TxidCheckFormProps> = ({
  defaultValues,
  onSubmit,
  loading,
}) => {
  const { handleSubmit, control } = useForm<TxidCheckFormData>({
    mode: 'onChange',
    defaultValues: {
      network: undefined,
      currency: undefined,
      txid: '',
      walletAddress: '',
      ...defaultValues,
    },
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Alert
        className="mb-4"
        type="info"
        showIcon
        message="Проверка по TXID показывает детали транзакции и проверяет отправителя на риски."
      />

      <Row gutter={16}>
        <Col {...colProps}>
          <Controller
            name="network"
            control={control}
            rules={{ required: 'Выберите сеть' }}
            render={({ field, fieldState: { error } }) => (
              <Form.Item
                label="Сеть"
                validateStatus={error ? 'error' : undefined}
                help={error?.message}
              >
                <Select
                  {...field}
                  placeholder="Выберите сеть"
                  options={WALLET_NETWORKS.map((value) => ({
                    value,
                    label: value,
                  }))}
                />
              </Form.Item>
            )}
          />
        </Col>
        <Col {...colProps}>
          <Controller
            name="currency"
            control={control}
            rules={{ required: 'Выберите валюту' }}
            render={({ field, fieldState: { error } }) => (
              <Form.Item
                label="Валюта"
                validateStatus={error ? 'error' : undefined}
                help={error?.message}
              >
                <Select
                  {...field}
                  placeholder="Выберите валюту"
                  options={WALLET_CURRENCIES.map((value) => ({
                    value,
                    label: value,
                  }))}
                />
              </Form.Item>
            )}
          />
        </Col>
        <Col {...colProps}>
          <Controller
            name="txid"
            control={control}
            rules={{
              validate: (value) => value.trim() !== '' || 'Укажите TXID',
            }}
            render={({ field, fieldState: { error } }) => (
              <Form.Item
                label="TXID (хеш транзакции)"
                validateStatus={error ? 'error' : undefined}
                help={error?.message}
              >
                <Input {...field} placeholder="вставь хеш транзакции..." />
              </Form.Item>
            )}
          />
        </Col>
        <Col {...colProps}>
          <Controller
            name="walletAddress"
            control={control}
            render={({ field }) => (
              <Form.Item label="Адрес кошелька для привязки (опционально)">
                <Input {...field} placeholder="TXxxx... — вставь адрес" />
              </Form.Item>
            )}
          />
        </Col>
      </Row>

      <Button
        type="primary"
        htmlType="submit"
        icon={<LinkOutlined />}
        disabled={loading}
        loading={loading}
      >
        Проверить транзакцию
      </Button>
    </form>
  )
}
